import { niumForexTransactionComputation } from '../../../../redux/actions/nium-forex/nium-forex-action';
import { HUNDRED_THOUSAND } from '../../../../utils/constants';
import { formatAmount } from '../../../../utils/library';
import { SEND_MONEY_CALCULATOR_SCREEN } from '../../utils/constants';

export const maskText = (input = ''): string =>
  input.replace(/[0-9a-zA-Z](?=[0-9a-zA-Z]{4})/gi, 'X');

export const formatComputedData: any = (data: any) => {
  let payload = null;
  const {
    instarem_fx_rate,
    destination_currency,
    net_source_amount,
    transaction_fee_amount,
    tax_amount_1,
    tax_amount_2,
    tax_amount_3,
    destination_amount,
    gross_source_amount,
    net_tax_amount,
    payment_method_fee_amount,
    net_of_fee_amount,
    payout_method_fee_amount,
    coupon_code,
    coupon_amount,
    fx_rate,
    margin_percent,
    margin_amount,
    transaction_fee_percent,
    tax_type_1,
    tax_type_2,
    tax_type_3,
    additional_info,
    payment_method_fee_percent,
    beneficiary,
    remitter_bank_name,
    remitter,
    remittance_type
  } = data;

  payload = {
    instaremFxRate: instarem_fx_rate,
    destinationCurrency: destination_currency,
    sourceAmount: gross_source_amount,
    netSourceAmount: net_source_amount,
    transactionFeeAmount: transaction_fee_amount,
    taxAmount1: tax_amount_1,
    taxAmount2: tax_amount_2,
    taxAmount3: tax_amount_3,
    destinationAmount: destination_amount,
    netTaxAmount: net_tax_amount,
    paymentMethodFeeAmount: payment_method_fee_amount,
    netOfFeeAmount: net_of_fee_amount,
    payoutMethodFeeAmount: payout_method_fee_amount,
    couponCode: coupon_code,
    couponAmount: coupon_amount,
    fxRate: fx_rate,
    marginPercent: margin_percent,
    marginAmount: margin_amount,
    transactionFeePercent: transaction_fee_percent,
    taxType1: tax_type_1,
    taxType2: tax_type_2,
    taxType3: tax_type_3,
    additionalInfo: additional_info,
    paymentMethodFeePercent: payment_method_fee_percent,
    remittanceType: remittance_type
  };
  if (beneficiary) {
    payload = {
      ...payload,
      beneDetails: {
        name: beneficiary.full_name,
        country: beneficiary.beneficiary_country_name,
        bankName: beneficiary.bank_name,
        accountNumber: maskText(beneficiary.bank_account_number),
        swiftCode: beneficiary.routing_code
      }
    };
  }

  if (remitter && remitter_bank_name) {
    payload = {
      ...payload,
      remitterDetails: {
        remitterName: remitter?.remitter_personal_info?.full_name ?? '',
        remitterBankName: remitter_bank_name ?? ''
      }
    };
  }
  return payload;
};

export const getComputedCurrency: any = async (
  amount: number,
  type: string,
  receiving_currency: string,
  couponCode: string | null = null,
  activateLoader: () => void,
  disableLoader: () => void,
  sourceCurrency: string,
  destinationCurrency: string,
  storeTransactionDetails: (data: any) => void,
  reasonForTransfer: number,
  sourceOfFunds: number,
  remittanceType: number | null
) => {
  activateLoader();
  const params: Record<string, any> = {
    source_currency: sourceCurrency || 'INR',
    destination_currency: receiving_currency || destinationCurrency || 'USD',
    transfer_type: SEND_MONEY_CALCULATOR_SCREEN?.bankTransfer,
    source_amount: amount ?? HUNDRED_THOUSAND,
    source_of_funds: sourceOfFunds || 1,
    reason_for_transfer: reasonForTransfer || 10,
    country_code: 'IN',
    coupon_code: couponCode,
    remittance_type: remittanceType
  };
  if (params?.destination_currency) {
    // Case when user changes the destination amount
    if (type === 'Destination') {
      delete params.source_amount;
      params.destination_amount = formatAmount(amount);
    }
    if (params?.source_amount || params?.destination_amount > 0) {
      const computedData = await niumForexTransactionComputation(params);

      if (computedData) {
        // return flag true if there is an error
        if (typeof computedData === 'string') {
          disableLoader();
          return { isError: true };
        } else {
          const payload = formatComputedData(computedData);
          //we must add these here because compute api does not return sourceOfFunds, remittanceType, reasonForTransfer
          storeTransactionDetails({
            ...payload,
            sourceOfFunds,
            reasonForTransfer,
            remittanceType,
            isCouponApplied: true
          });
          disableLoader();
          return { sourceAmount: computedData?.net_source_amount, isError: false };
        }
      }

      disableLoader();
    }
  }
};
